/*
 *
 * DivisionAnalysis reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_DRILLDOWN_DIVISIONS_WATCHER,
  GET_DRILLDOWN_DIVISIONS_SUCCESS,
  GET_DIMENSIONS_WATCHER,
  GET_DIMENSIONS_SUCCESS,
  GET_DRILLDOWN_DIVISIONS_FAILED,
  GRAPHIC_BARS_WATCHER,
  GRAPHIC_BARS_SUCCESS,
  GRAPHIC_BARS_FAILED,
  DIVISION_WITH_ENGAGEMENT_SUCCESS,
  DIVISION_WITH_ENGAGEMENT_WATCHER,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  divisions: [],
  dimensions: [],
  levels: [],
  divisionsDrillDown: [],
  metric: {},
  showHistory: false,
  switchMoreDimensions: false,
  graphicBars: [],
  isLoadingGraphicBars: false,
  divisionsWithEngagement: [],
  measureColorRange: null,
  metricsTotalLabel: "",
  measureInfo: {},
  isEngagement: false,
  isEngagementOnly: false,
  isLoadingDivision: false,
  isLoadingDivEng: false,
  idMeasure: null
})

function divisionAnalysisReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DRILLDOWN_DIVISIONS_WATCHER:
      return state
        .set("isLoadingDivision", true)
        .set("divisions", [])
        .set("divisionsDrillDown", [])
        .set("metric", {})
    case GET_DRILLDOWN_DIVISIONS_SUCCESS:
      return state
        .set("isLoadingDivision", false)
        .set("divisions", action.payload.data)
        .set("divisionsDrillDown", action.payload.data_drilldown)
        .set("metric", action.payload.metric)
        .set(
          "levels",
          Array.isArray(state.get("levels"))
            ? state.get("levels").length === 0
              ? action.payload.levels
              : state.get("levels")
            : action.payload.levels
        )
    case GET_DRILLDOWN_DIVISIONS_FAILED:
      return state
        .set("isLoadingDivision", false)
        .set("divisions", [])
        .set("divisionsDrillDown", [])
        .set("metric", {})
        .set(
          "levels",
          Array.isArray(state.get("levels"))
            ? state.get("levels").length === 0
              ? action.payload.levels
              : state.get("levels")
            : action.payload.levels
        )
    case GET_DIMENSIONS_WATCHER:
      return state
        .set("isLoading", true)
        .set("dimensions", [])
        .set("showHistory", false)
        .set("switchMoreDimensions", false)
    case GET_DIMENSIONS_SUCCESS:
      return state
        .set("isLoading", false)
        .set("dimensions", action.payload.dimensions)
        .set("showHistory", action.payload.showHistory)
        .set("switchMoreDimensions", action.payload.switchMoreDimensions)

    case GRAPHIC_BARS_WATCHER:
      return state.set("graphicBars", []).set("isLoadingGraphicBars", true)
    case GRAPHIC_BARS_SUCCESS:
      return state
        .set("graphicBars", action.payload)
        .set("isLoadingGraphicBars", false)
    case GRAPHIC_BARS_FAILED:
      return state.set("graphicBars", []).set("isLoadingGraphicBars", false)

    case DIVISION_WITH_ENGAGEMENT_WATCHER:
      return state
        .set("isLoadingDivEng", true)
        .set("divisionsWithEngagement", [])
    case DIVISION_WITH_ENGAGEMENT_SUCCESS:
      return state
        .set("isLoadingDivEng", false)
        .set("divisionsWithEngagement", action.payload.data)

    case GET_MEASURE_COLOR_RANGE_SUCCESS:
      return state.set("measureColorRange", action.payload.report_color_range)

    case GET_MEASURE_SUCCESS:
      return state
        .set("idMeasure", action.payload.id_measure)
        .set("measureInfo", action.payload)
        .set("isEngagement", action.payload.is_engagement)
        .set(
          "isEngagementOnly",
          action.payload.is_engagement && !action.payload.has_enps
        )

    default:
      return state
  }
}

export default divisionAnalysisReducer
